module.exports = __webpack_public_path__ + "img/Feature-3.fcb2644.svg";